import React from 'react';

const NotFound = () => {
  return <h1>404 Page NotFound</h1>;
};

export default NotFound;
